if (typeof EstimatedDelivery !== 'function') {
	class EstimatedDelivery extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				productPage: 'product-page',
				productForm: '.product-form',
				form: '[action="/cart/add"]',
				addToCart: 'button[type="submit"]',
				estimate: '.estimated__delivery-text',
				preOrderInput: 'product-preOrder',
			};

			this.classes = {
				visible: 'estimated__delivery--visible',
				productUnavailable: 'product-pickup--unavailable',
				isBadge: 'estimated__delivery--use-badge',
			};

			// Elements product-pickup--unavailable
			this.productPage = this.closest(this.selectors.productPage);
			this.productForm = this.closest(this.selectors.productForm);
			this.form = this.productForm ? this.productForm.querySelector(this.selectors.form) : null;
			this.addToCart = this.productForm ? this.productForm.querySelector(this.selectors.addToCart) : null;
			this.estimate = this.querySelector(this.selectors.estimate);
			this.storeSelector = document.querySelector('store-selector');

			// Variables
			this.months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

			// Flags
			this.isPreOrder = this.dataset.preOrder === 'true' ? true : false;
			this.isProductPage = this.hasAttribute('data-product-page');
			this.preOrderLocations =
				this.dataset.preOrderLocations && this.dataset.preOrderDates != ''
					? JSON.parse(this.dataset.preOrderLocations)
					: null;
			this.preOrderDates =
				this.dataset.preOrderDates && this.dataset.preOrderDates != ''
					? JSON.parse(this.dataset.preOrderDates)
					: null;
			this.formattedLocations = [];

			this.init();
		}

		init() {
			const { isPreOrder, preOrderDates, formattedLocations, classes } = this;

			this.formatLocations();
			this.addEventListeners();

			if (this.classList.contains(classes.isBadge)) {
				this.setDate();
			}
		}

		addEventListeners() {
			window.addEventListener('load', () => {
				if (this.storeSelector) {
					this.storeSelector.addEventListener('storechanged', (e) => {
						this.setDate();
					});
				}
			});

			if (this.productPage) {
				const variants = this.productPage.querySelector('product-variants');
				if (variants) {
					variants.addEventListener('VARIANT_CHANGE', (e) => {
						const variant = e.target.currentVariant;
						this.onVariantChange(variant);
					});
				}
			}
		}

		setDate() {
			const selectedStoreHasPreOrder = this.selectedStoreHasPreOrder();

			if (selectedStoreHasPreOrder) {
				const date = this.getSelectedStoreDate();

				this.updateDeliveryDate(date);
			} else {
				this.clearEstimate();
			}
		}

		getSelectedStoreDate() {
			const { formattedLocations, preOrderDates } = this;

			const selectedStore = this.getSelectedStore();
			const index = formattedLocations.indexOf(selectedStore);

			if (index !== -1 && index < preOrderDates.length) {
				return preOrderDates[index];
			}

			return null;
		}

		selectedStoreHasPreOrder() {
			const { formattedLocations } = this;

			const selectedStore = this.getSelectedStore();

			if (formattedLocations.includes(selectedStore)) {
				return true;
			}

			return false;
		}

		formatLocations() {
			const { preOrderLocations, formattedLocations } = this;

			if (preOrderLocations) {
				for (let i = 0; i < preOrderLocations.length; i++) {
					const formattedLocation = preOrderLocations[i].toLowerCase().replace(/ /g, '-').replace(/,/g, '');
					formattedLocations.push(formattedLocation);
				}
			}
		}

		addBusinessDays(date, days) {
			let count = 0;
			let current = new Date(date.getTime());

			while (count < days) {
				current.setDate(current.getDate() + 1);
				if (current.getDay() !== 0 && current.getDay() !== 6) {
					count++;
				}
			}

			return current;
		}

		formatDate(date) {
			const { months } = this;

			return `${months[date.getMonth()]} ${date.getDate()}`;
		}

		updateDeliveryDate(date = null) {
			const { isProductPage, addToCart, estimate, classes } = this;

			if (date) {
				const initialDate = new Date(date);
				let firstDate = null;
				let lastDate = null;

				if (!isNaN(initialDate.getTime())) {
					firstDate = initialDate;
					lastDate = this.addBusinessDays(new Date(firstDate), 5);
				}

				if (firstDate && lastDate) {
					const fullDate = `${this.formatDate(firstDate)} - ${this.formatDate(lastDate)}`;
					this.classList.add(classes.visible);

					if (isProductPage) {
						estimate.innerText = `${KROWN.settings.locales.preorder_text} ${fullDate}`;
						this.setProductProperty(fullDate);
						addToCart.innerText = KROWN.settings.locales.product_pre_order;
					} else {
						estimate.innerText = KROWN.settings.locales.product_pre_order;
					}
				}
			} else {
				this.clearEstimate();
			}
		}

		getSelectedStore() {
			const selectedStore = localStorage.getItem('selected-store');

			return selectedStore;
		}

		setProductProperty(fullDate) {
			const { form, selectors } = this;

			const input = document.createElement('input');
			input.setAttribute('type', 'hidden');
			input.setAttribute('id', selectors.preOrderInput);
			input.setAttribute('name', 'properties[Pre-Order]');
			input.setAttribute('value', fullDate);

			form.append(input);
		}

		clearEstimate() {
			const { isProductPage, estimate, form, selectors, classes } = this;

			this.classList.remove(classes.visible);
			estimate.innerText = '';

			if (isProductPage) {
				const input = form.querySelector(`#${selectors.preOrderInput}`);
				if (input) input.remove();
			}
		}

		onVariantChange(variant) {
			const { addToCart } = this;

			const variantId = variant.id;
			const variantSectionUrl = `${this.dataset.baseUrl}/variants/${variantId}/?section_id=helper-estimated-delivery`;

			const addToCartText =
				variant && variant.available
					? KROWN.settings.locales.products_add_to_cart_button
					: KROWN.settings.locales.products_unavailable_variant;

			addToCart.innerText = addToCartText;

			fetch(variantSectionUrl)
				.then((response) => response.text())
				.then((text) => {
					const sectionInnerHTML = new DOMParser()
						.parseFromString(text, 'text/html')
						.querySelector('.shopify-section');

					this.updateAttributes(sectionInnerHTML);
				})
				.catch((e) => {
					console.log(e);
				});
		}

		updateAttributes(html) {
			const estimatedDelivery = html.querySelector('estimated-delivery');

			if (estimatedDelivery) {
				const variantId = estimatedDelivery.getAttribute('data-variant-id');
				const isPreOrder = estimatedDelivery.getAttribute('data-pre-order');

				if (isPreOrder === 'true') {
					this.formattedLocations = [];
					const preOrderLocations = JSON.parse(estimatedDelivery.getAttribute('data-pre-order-locations'));
					const preOrderDates = JSON.parse(estimatedDelivery.getAttribute('data-pre-order-dates'));

					if (variantId) this.setAttribute('data-variant-id', variantId);
					if (isPreOrder) this.setAttribute('data-pre-order', isPreOrder);
					if (preOrderLocations) {
						this.preOrderLocations = preOrderLocations != '' ? preOrderLocations : null;
						this.setAttribute('data-pre-order-locations', JSON.stringify(preOrderLocations));
					}
					if (preOrderDates) {
						this.preOrderDates = preOrderDates != '' ? preOrderDates : null;
						this.setAttribute('data-pre-order-dates', JSON.stringify(preOrderDates));
					}

					this.formatLocations();

					this.setDate();
				} else {
					this.clearEstimate();
				}
			}
		}
	}

	if (typeof customElements.get('estimated-delivery') == 'undefined') {
		customElements.define('estimated-delivery', EstimatedDelivery);
	}
}
